'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/* injects from baggage-loader */

exports.default = projects;

var _actionTypes = require('../constants/actionTypes');

var initialState = {
  list: null,
  project: null,

  shareLoaded: false,
  shareLoading: false,

  shareLink: null,
  sharePopupOpened: false
};

function projects() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments[1];


  switch (action.type) {
    case _actionTypes.SET_PROJECTS_LIST:
      return _extends({}, state, {
        list: action.value
      });

    case _actionTypes.SET_PROJECT:
      return _extends({}, state, {
        project: action.value
      });

    case _actionTypes.SHARE_PROJECT:
      return _extends({}, state, {

        shareLoaded: false,
        shareLoading: true,
        shareLink: null,

        sharePopupOpened: false
      });

    case _actionTypes.SHARE_PROJECT_GOT_FB_LINK:
      return _extends({}, state, {

        shareLoaded: true,
        shareLoading: false,
        shareLink: action.link
      });

    case _actionTypes.SHARE_PROJECT_SUCCESS:
      return _extends({}, state, {

        shareLoaded: true,
        shareLoading: false
      });

    case _actionTypes.SHARE_PROJECT_POPUP_OPENED:
      return _extends({}, state, {
        sharePopupOpened: true
      });

    case _actionTypes.SHARE_PROJECT_FAILURE:
      return _extends({}, state, {
        shareLoading: false,
        shareLoaded: false,
        shareLink: action.link
      });

    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./app/reducers/projects.js
// module id = 629
// module chunks = 1